export enum CallEventType {
    callPlaced = 'call_placed',
    operatorConnected = 'operator_connected',
    holdStarted = 'hold_started',
    holdEnded = 'hold_ended',
    transfer = 'transfer',
    customerSwitched = 'customer_switched',
    participantJoined = 'participant_joined',
    participantLeft = 'participant_left',
    guestInvited = 'guest_invited',
    videoUpgraded = 'video_upgraded',
    emailSent = 'email_sent',
    messageSent = 'message_sent',
    reportFiled = 'report_filed',
    recordingGenerated = 'recording_generated',
    callEnded = 'call_ended',
    callTimedOut = 'call_timed_out',
    feedbackReceived = 'feedback_received',
}

export interface CallEvent {
    id: string
    call_id: string
    type: CallEventType
    actor_user_id?: string
    target_user_id?: string
    actor?: { id: string; name: string }
    target?: { id: string; name: string }
    participant?: string
    metadata?: Record<string, any>
    created_at: string
}
